import { BatchInformationTable, ProductInformationTable } from "../Tables";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: "100%",
  },
  overview: {
    width: "100%",
    textAlign: "left",
    color: theme.palette.text.secondary,
    // These were initially set, Im not sure why though. These rules break they layout when the resolution is set high (3840 x 2160)
    // minHeight: "30vh",
    // maxHeight: "30vh",
  },
  filter: {
    textAlign: "left",
    color: theme.palette.text.secondary,
    width: "100%",
    margin: "auto",
  },
  card: {},
}));

function Overview(props) {
  const classes = useStyles();
  const { facilityMap } = props.state.lists;

  return (
    <Box className={classes.root}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <Paper className={classes.overview} elevation={0}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <h4 style={{ textAlign: "left" }}>Product Information</h4>
                <ProductInformationTable state={props.state} />
              </Grid>
              <Grid item xs={12}>
                <h4 style={{ textAlign: "left" }}>Batch Information</h4>
                <BatchInformationTable
                  timeZone={props.timeZone}
                  state={props.state}
                  facilityMap={facilityMap}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Overview;
